import { createContext, useContext } from "react";

export const TableColumnsContext = createContext({
  tableColumnsData: null,
  setTableColumnsData: () => { },
  getTableColumns: () => { },
});

export const useTableColumns = () => useContext(TableColumnsContext);

export default TableColumnsContext;
